import { CheckCircle, PlayArrow, Schedule, WarningAmber } from "@mui/icons-material";
import { colors } from "../../../../../../ui/colors";

  export const getStatusLabel = (status) => {
    switch (status) {
      case 0:
        return { label: "Waiting for worker punch", color: colors.gray[500], bg: colors.gray[100], icon: <Schedule /> };
      case 1:
        return { label: "Working", color: colors.blue.base, bg: colors.blue[50], icon: <PlayArrow /> };
      case 2:
        return { label: "Completed", color: colors.success.base, bg: colors.success[50], icon: <CheckCircle /> };
      case 3:
        return { label: "Worker late", color: colors.orange.base, bg: colors.orange[50], icon: <WarningAmber /> };
      default:
        return { label: "Unknown", color: colors.gray[500], bg: colors.gray[100], icon: <Schedule /> };
    }
  };
